import React, { useState, useRef } from 'react';
import { Grid, Box, Typography, TextField, Button, Link } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';

import { useLocation, useNavigate } from 'react-router-dom';

export default function Otpverificationpage() {
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef([]);

  const location = useLocation();
  const email = location.state?.email;
  const navigate = useNavigate();

  const handleChange = (index, value) => {
    if (!isNaN(value) && value.length <= 1) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      if (value && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const otpvalue = otp.join('');
  const data = { email: email, otp: otpvalue };
  const sendotp = () => {
    axios.post(`${process.env.REACT_APP_API_LINKS}/forgot/sendotp`, data)
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'OTP Sent Successfully!',
            timer: 1000,
            showConfirmButton: false
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 300) {
          Swal.fire({
            icon: 'error',
            title: 'No user found!',
            text: 'no users with that email.',
            timer: 1000,
            showConfirmButton: false
          });
        }
        else {


          Swal.fire({
            icon: 'error',
            title: 'Failed to send OTP!',
            text: 'An error occurred while sending the OTP.',
            timer: 1000,
            showConfirmButton: false
          });
        }
      });

  };

  const verifyotp = () => {
    axios
      .post(`${process.env.REACT_APP_API_LINKS}/forgot/verifyotp`, data)
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'OTP Verified Successfully!',
            timer: 1000,
            showConfirmButton: false
          });
          navigate('/changepassword', { state: { email: email } });
        }
      })
      .catch((err) => {
        if (err.response.status === 300) {
          Swal.fire({
            icon: 'error',
            title: 'OTP Mismatch!',
            text: 'The OTP you entered is incorrect.',
            timer: 1000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Server Error!',
            text: 'Something went wrong with the verification.',
            timer: 1000,
            showConfirmButton: false
          });
        }
      });
  };

  return (
    <Grid
      container
      sx={{
        minHeight: '100vh',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 2, sm: 4, md: 8 },
        py: { xs: 4, md: 6 },
        gap: { xs: 4, md: 0 }
      }}
    >
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          mb: { xs: 2, md: 0 },
          px: { xs: 2, sm: 4 },
          mr: { lg: 15 },


        }}
      >
        <img
          src="suntech_logo.png"
          alt="Logo"
          style={{ height: 75, marginBottom: 12 }}
        />

        <Typography
          variant="h4"
          sx={{
            mt: 3,
            fontWeight: 600,
            fontFamily: 'poppins',
            fontSize: { xs: '22px', sm: '32px' }
          }}
        >
          Welcome
        </Typography>

        <img
          src="otp.png"
          alt="OTP sending image"
          style={{ width: '80%', maxWidth: 500, marginTop: 40 }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: { xs: 0, md: 0 },
          px: { xs: 2, sm: 3 },
          ml: { md: 0, lg: 10 }
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            p: { xs: 3, sm: 4 },
            boxShadow: 5,
            borderRadius: 2,
            textAlign: 'center',
            backgroundColor: '#fff',
            mx: 'auto'
          }}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 600,
              fontFamily: 'poppins',
              fontSize: { xs: '18px', sm: '24px' },

            }}
          >
            Verify Code
          </Typography>

          <Typography
            variant="body2"
            sx={{
              mb: 3,
              fontFamily: 'poppins',
              color: 'text.secondary',
              fontSize: { xs: '14px', sm: '16px' }
            }}
          >
            Enter your 4 digit password reset code
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              mb: 3
            }}
          >
            {otp.map((digit, index) => (
              <TextField
                key={index}
                value={digit}
                inputRef={(el) => (inputRefs.current[index] = el)}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: 'center',
                    fontSize: '20px',
                    padding: '12px',
                    width: '20px',
                    height: '20px',
                    fontFamily: 'poppins'
                  }
                }}
              />
            ))}
          </Box>
            <Box sx={{textAlign:'center',justifyContent:'center'}}>
          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: '#007ee5',
              textTransform: 'none',
              fontWeight: 600,
              mb: 2,
              width:'150px',
              display:'block',
              margin:'auto',
              mb:2,
              borderRadius:'10px'
            }}
            onClick={verifyotp}
          >
            Verify
          </Button>

          <Button variant='text'
            onClick={sendotp}
            underline="hover"
            sx={{
              fontSize: '12px',
              fontWeight: 600,
              color: 'text.secondary',
              fontFamily: 'poppins',
              display:'block',
              margin:'auto',
              mt:2
            }}
          >
            Resend Code
          </Button>
          </Box>
        </Box>

      </Grid>
    </Grid>
  );
}
